import React, { useState, FormEvent } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { resetPassword } from "../../api";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const ResetPassword: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token: string | null = searchParams.get("token");

  const [newPassword, setNewPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [submitted, setSubmitted] = useState<boolean>(false);

  const handleReset = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!newPassword || !confirmPassword) {
      toast.error("Please fill in all fields.");
      return;
    }

    if (newPassword.length < 6) {
      toast.error("Password must be at least 6 characters.");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }

    if (!token) {
      toast.error("Invalid or missing token.");
      return;
    }

    setLoading(true);
    try {
      await resetPassword(token, newPassword);
      toast.success("Password has been reset successfully. You may now log in.");
      setSubmitted(true);
    } catch (err: any) {
      const msg = err?.response?.data?.message || "Failed to reset password.";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#000",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <form
          onSubmit={handleReset}
          className="d-flex flex-column gap-3"
          style={{
            width: "100%",
            maxWidth: "400px",
            color: "#fff",
            padding: "20px",
          }}
        >
          <h3 className="text-center">Reset Password</h3>

          <input
            type="password"
            className="form-control bg-dark text-white border-secondary"
            placeholder="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            disabled={submitted}
          />

          <input
            type="password"
            className="form-control bg-dark text-white border-secondary"
            placeholder="Confirm New Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            disabled={submitted}
          />

          <button
            type="submit"
            disabled={loading || submitted}
            className="main-btn btn-hover mt-2"
            style={{
              borderRadius: "100px",
              background:
                "linear-gradient(to right,rgb(255, 101, 163),rgb(254, 163, 52))",
            }}
          >
            {loading ? "Resetting..." : "Reset Password"}
          </button>

          <p className="text-center mt-3">
            <button
              type="button"
              onClick={() => navigate("/login")}
              className="btn btn-link text-white"
              style={{ textDecoration: "underline" }}
            >
              Back to Login
            </button>
          </p>
        </form>
      </div>

      <ToastContainer />

      <div
        className="copyright-footer"
        style={{
          color: "#fff",
          textAlign: "center",
          padding: "10px 0",
        }}
      >
        © {new Date().getFullYear()}, Eventox. All rights reserved.
      </div>
    </div>
  );
};

export default ResetPassword;
